import {TOGGLE_PRICES} from "../actions/types";
import initialState from './initialState';
import Cookies from 'universal-cookie';

export default (prevState = initialState.showPrices, action) => {
    switch (action.type) {

        case TOGGLE_PRICES:
            const cookies = new Cookies();
            if(!prevState) {
                cookies.set('smloc', true, { path: '/' });
            } else {
                cookies.remove('smloc', { path: '/' });
            }
            return !prevState;
        default:
            return prevState;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/togglePriceReducer.js